/* eslint-disable no-restricted-imports */
import clsx from 'clsx'
import React from 'react'
import styles from './UIGameCard.module.scss'
import {CardEnum, PlayerColor} from '@colonist/game-states'
import {Tooltip} from '../Tooltip'
import {T} from '../T'
import {UIGameCount} from '../UIGameCount/UIGameCount'
import {Placement} from '@floating-ui/react'
import {CARD_IMAGES, CARD_TIP_BODY, CARD_TIP_TITLE} from '@colonist/ui-game'

const CountBadge = ({count}: { count: number }) => (
    <UIGameCount
        className={styles.countBadge}
        color={PlayerColor.Blue}
        count={count}
    />
)

interface CardContentProps {
    className: string
    cardEnum: CardEnum
    onClick: VoidFunction | undefined
    count: number | undefined
}

const CardContent = ({className, cardEnum, onClick, count}: CardContentProps) => (
    <div
        className={clsx(styles.container, className)}
        onClick={onClick}
    >
        <img
            className={styles.cardImage}
            src={CARD_IMAGES[cardEnum]}
        />
        {count != undefined && <CountBadge count={count} />}
    </div>
)

export interface UIGameCardProps {
    cardEnum: CardEnum
    className?: string
    onClick?: (cardEnum: CardEnum) => void
    showTipTitle?: boolean
    showTipBody?: boolean
    count?: number
    tooltipPosition?: Placement
}

const UIGameCardComponent = ({
    className = '',
    cardEnum,
    showTipTitle = false,
    showTipBody = false,
    onClick,
    count = undefined,
    tooltipPosition = 'top',
}: UIGameCardProps) => {
    const handleClick: VoidFunction | undefined = onClick ? () => onClick(cardEnum) : undefined

    const cardContent = (
        <CardContent
            className={className}
            count={count}
            cardEnum={cardEnum}
            onClick={handleClick}
        />
    )

    if(showTipTitle || showTipBody) {
        return <Tooltip
            centerText={false}
            content={showTipBody ? <T id={CARD_TIP_BODY[cardEnum]}/> : undefined}
            menuClassName={styles.tooltipMenu}
            position={tooltipPosition}
            title={showTipTitle ? <T id={CARD_TIP_TITLE[cardEnum]}/> : undefined}>
            {cardContent}
        </Tooltip>
    }
    return cardContent
}

export const UIGameCard = React.memo(UIGameCardComponent)
